/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProgressList = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m21.293 16.293 1.414 1.414L18 22.414l-2.707-2.707 1.414-1.414L18 19.585zM13 19v2H2v-2zm8.293-9.707 1.414 1.414L18 15.414l-2.707-2.707 1.414-1.414L18 12.585zM13 11v2H2v-2zm8.293-9.707 1.414 1.414L18 7.414l-2.707-2.707 1.414-1.414L18 4.585zM13 3v2H2V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgProgressList as ProgressList };
